import React, { createContext, useState, useEffect } from "react";
import axios from "axios";
import * as signalR from "@microsoft/signalr";
import API_ENDPOINTS from "../../config/api";

const ChatContext = createContext();

export const ChatProvider = ({ children }) => {
  const [chatUsers, setChatUsers] = useState([]);
  const [activeChatUser, setActiveChatUser] = useState(null);
  const [connection, setConnection] = useState(null);

  // 📌 Lấy danh sách user từ API
  const fetchChatUsers = async () => {
    try {
      const res = await axios.get(API_ENDPOINTS.chatUsers, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      setChatUsers(res.data);
    } catch (err) {
      console.error("❌ Lỗi lấy danh sách user:", err);
    }
  };

  // 📌 Khởi tạo SignalR connection
  const initSignalR = async () => {
    if (connection) return; // tránh tạo nhiều lần

    const conn = new signalR.HubConnectionBuilder()
      .withUrl(API_ENDPOINTS.chatHub, {
        accessTokenFactory: () => localStorage.getItem("token"),
      })
      .withAutomaticReconnect()
      .build();

    // Khi nhận tin nhắn
    conn.on("ReceiveMessage", (fromUserId, message) => {
      console.log("📩 Tin nhắn mới:", fromUserId, message);
      // TODO: bạn có thể cập nhật state chatMessages ở đây nếu muốn
    });

    // Khi user online
    conn.on("UserOnline", (userId) => {
      setChatUsers((prev) =>
        prev.map((u) =>
          u.id === parseInt(userId) ? { ...u, online: true } : u
        )
      );
    });

    // Khi user offline
    conn.on("UserOffline", (userId) => {
      setChatUsers((prev) =>
        prev.map((u) =>
          u.id === parseInt(userId) ? { ...u, online: false } : u
        )
      );
    });

    try {
      await conn.start();
      console.log("✅ SignalR connected.");
      setConnection(conn);
    } catch (err) {
      console.error("❌ SignalR connect error:", err);
    }
  };

  // 📌 Gửi tin nhắn
  const sendMessage = async (toUserId, message) => {
    if (!connection) {
      console.warn("⚠️ Chưa có kết nối SignalR");
      return;
    }
    try {
      await connection.invoke("SendMessage", toUserId, message);
    } catch (err) {
      console.error("❌ Lỗi gửi tin nhắn:", err);
    }
  };

  // 📌 Gọi khi load app
  useEffect(() => {
    fetchChatUsers();
    initSignalR();

    return () => {
      if (connection) {
        connection.stop();
        console.log("🛑 SignalR disconnected.");
      }
    };
  }, []);

  return (
    <ChatContext.Provider
      value={{
        chatUsers,
        setChatUsers,
        activeChatUser,
        setActiveChatUser,
        connection,
        sendMessage,
      }}
    >
      {children}
    </ChatContext.Provider>
  );
};

export default ChatContext;
